<form [formGroup]="group">
    <mat-form-field class="w100" [class.readonly-field]="readonly" [floatLabel]="readonly ? 'always' : 'auto'">
        <mat-label>{{ label | translate }}</mat-label>
        <input *ngIf="!textarea" matInput [formControlName]="controlName" [maxlength]="maxlength" [minlength]="minlength"
            [type]="type" [min]="min" [max]="max" [step]="step" [readonly]="readonly" (input)="input.emit()"
            (change)="change.emit()" />
        <textarea *ngIf="textarea" matInput cdkTextareaAutosize [formControlName]="controlName" [maxlength]="maxlength"
            [minlength]="minlength" [readonly]="readonly" (input)="input.emit()" (change)="change.emit()"></textarea>
        <mat-hint *ngIf="hint">{{ hint | translate }}</mat-hint>
        <mat-error *ngFor="let error of group.controls[controlName]?.errors | keyvalue">
            <span [ngSwitch]="error.key">
                <ng-container *ngSwitchCase="'maxlength'">
                    {{ 'ALDEN.VALIDATORS.ERRORS.MAX_LENGTH' | translate : { 'length':
                    error.value.maxlength.requiredLength } }}
                </ng-container>
                <ng-container *ngSwitchCase="'minlength'">
                    {{ 'ALDEN.VALIDATORS.ERRORS.MIN_LENGTH' | translate : { 'length':
                    error.value.minlength.requiredLength } }}
                </ng-container>
                <ng-container *ngSwitchCase="'max'">
                    {{ 'ALDEN.VALIDATORS.ERRORS.MAX' | translate : { 'value':
                    error.value.max } }}
                </ng-container>
                <ng-container *ngSwitchCase="'min'">
                    {{ 'ALDEN.VALIDATORS.ERRORS.MIN' | translate : { 'value':
                    error.value.min } }}
                </ng-container>
                <ng-container *ngSwitchCase="'required'">
                    {{ 'ALDEN.VALIDATORS.ERRORS.REQUIRED' | translate }}
                </ng-container>
                <ng-container *ngSwitchCase="'pattern'">
                    {{ 'ALDEN.VALIDATORS.ERRORS.PATTERN' | translate }}
                </ng-container>
                <ng-container *ngSwitchDefault>
                    {{ error.value | translate }}
                </ng-container>
            </span>
        </mat-error>
        <button *ngIf="readonly" mat-icon-button matSuffix tabindex="-1"
            [color]="group.controls[controlName].invalid && group.controls[controlName].touched  ? 'warn' : ''"
            [matTooltip]="'ALDEN.MESSAGES.INFO.READONLY_FIELDS' | translate" type="button"
            (click)="$event.preventDefault(); $event.stopPropagation()">
            <mat-icon>info</mat-icon>
        </button>
    </mat-form-field>
</form>